<template>
    <div>
        <div id='product-reviews-scroll'></div>
        <div class='container' v-show='!loading'>
            <div class='reviews-container'>
                <div class='title'>Reviews</div>
                    <div class='filter-reviews-container'>
                        <FilterReviewsByStar :star_filters='star_filters' @reviewFilterListener='filterReviews' v-show='total_reviews != 0'/>
                        <ReviewSummary :total_reviews='total_reviews' :average_rating='average_rating' v-show='total_reviews != 0' />
                        <div class='no-reviews-text' v-show='total_reviews == 0'>
                            No reviews - be the first to leave a review
                        </div>
                    </div>

                <template v-for='review in reviews' :key='review.id'>
                    <Review :logged_in='logged_in' :review='review'/>
                </template>

                <Pagination name="review_pagination" :pagination_data="pagination_data" :total_rows="total_reviews" @paginationClickListener="paginationClick"/>

                <CreateReview :product_id='product_id' v-show='logged_in === true' :product_on_popout='product_on_popout' :logged_in='logged_in' />
           
                <Button v-show='logged_in === false' class='log-in' text='Log in to post a review' theme='dark' @click='logIn'/>
            
            </div>
        </div>
        <div v-if='loading' class='loading-container'>
            <Loading/>
        </div>

    </div>
</template>

<script>
import Ratings from '@/ecom/components/products/single_product/reviews/Ratings.vue';
import Review from '@/ecom/components/products/single_product/reviews/Review.vue';
import FilterReviewsByStar from '@/ecom/components/products/single_product/reviews/FilterReviewsByStar.vue';
import ReviewSummary from '@/ecom/components/products/single_product/reviews/ReviewSummary.vue';
import CreateReview from '@/ecom/components/products/single_product/reviews/CreateReview.vue';
import Pagination from '@/ecom/components/pagination/Pagination.vue';
import {checkAuth} from "@/global/modules/functions.js";
import Button from '@/ecom/components/buttons/Button.vue';
import Loading from '@/ecom/components/loading/Loading.vue';

export default {
    // props: ['reviews', 'total_reviews', 'average_rating', 'star_filters'],
    props: ['product_on_popout', 'product_id', 'product_code_changed_watcher'],
    components: {Ratings, Review, FilterReviewsByStar, ReviewSummary, Pagination, CreateReview, Button, Loading},
    emits: ['reviewsListener'],
    data(){
        return{
            review_search: '',
            reviews: [],
            total_reviews: 0,
            star_filters: {},
            average_rating: 0,
            filter_by_rating: 0,
            pagination_data:{
                rows_per_page : 10,
                current_page : 1,
                starting_row_number : 0,
                ending_row_number : 0,
            },
            logged_in: false,
            loading: true
        }
    },
    methods:{
        async getReviews(){
            this.loading = true;

            let response = await fetch(`/api/product/reviews?product_code=${this.product_id}&filter_by_rating=${this.filter_by_rating}&pagination_data=${JSON.stringify(this.pagination_data)}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.loading = false;
                this.reviews = results.reviews;
                this.average_rating = results.average_rating;
                this.total_reviews = results.total_reviews;
                this.star_filters = results.star_filters;
                this.$emit('reviewsListener', this.total_reviews, this.average_rating);
                this.logged_in = results.logged_in;
            }
        },
        filterReviews(rating){
            this.filter_by_rating = rating
            this.getReviews();
        },
        paginationClick(name, current_page_number, starting_row_number, ending_row_number){
            this.pagination_data.current_page = current_page_number;
            this.pagination_data.starting_row_number = starting_row_number;
            this.pagination_data.ending_row_number = ending_row_number;
            this.getReviews();
            this.ScrollToReviews();
        },
        ScrollToReviews(){
            const y_offset = 50; 
            const element = document.getElementById('product-reviews-scroll');
            const y = element.getBoundingClientRect().top + window.pageYOffset + y_offset;
            
            window.scrollTo({top: y, behavior: 'smooth'});
        },
        logIn(){
            this.$router.push('/login');
        }
    },
    beforeMount(){
        // if(!this.product_on_popout){
        //     this.getReviews();
        // }
    },
    watch:{
        'product_code_changed_watcher': function(){
            this.review_search = '',
            this.reviews = [],
            this.total_reviews = 0,
            this.star_filters = {},
            this.average_rating = 0,
            this.filter_by_rating = 0,
            this.pagination_data ={
                rows_per_page : 10,
                current_page : 1,
                starting_row_number : 0,
                ending_row_number : 0,
            }

            // if(this.product_on_popout){
                this.getReviews();
            // }
        }
    }
}
</script>

<style lang='scss' scoped>
.container{
    display: flex;
    justify-content: center;
}

.filter-reviews-container{
    background-color: #f1f3f5;
    width: 100%;
    padding: 20px 50px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 20px;
    @media(max-width: 768px){
        padding: 20px 30px;
    }
}

.reviews-container{
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items:  center;
    width: 1000px;

    @media(max-width: 1000px){
        width: 80%;
    }
}

.filter-reviews-section{
    display: flex;
    align-items: center;
}

.title{
    font-size: 1.8rem;
    color: var(--black);
}

.number-of-reviews-text{
    color: #495057;
    font-size: 0.95rem;
}

.search-bar{
    width: 300px;
    height: 40px;
    border-radius: 2px;
    border: solid 0.5px #dee2e6;
    padding: 1px 35px 1px 20px;
    font-size: 1rem;
    font-size: 0.9rem;
}

.search-bar-icon{
    z-index: 3;
    margin-left: -30px;
    width: 25px;
    color: var(--primary-colour-2);
    font-size: 1rem;
}

.clear-search-icon{
    cursor: pointer;
}

.no-reviews-text{
    font-size: 1rem;
    color: var(--black);
}

.log-in{
    width: 300px;
    margin-top: 24px;
}

.loading-container{
    width: 75px;
    height: 75px;
    margin: auto;
    margin-top: 50px;
}

</style>